// Real Copenhagen content + rule-based day-planner logic

export const NEIGHBORHOODS = [
  {
    id: "indre-by",
    name: "Indre By",
    tag: "The Old Town",
    color: "#FF4D00",
    blurb:
      "The medieval core. Cobbled lanes, the Strøget shopping mile, Rundetårn and Kongens Nytorv. Where every first visit begins.",
    highlights: ["Strøget", "Rundetårn", "Torvehallerne", "Kongens Nytorv"],
    image:
      "https://images.unsplash.com/photo-1513622470522-26c3c8a854bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "nyhavn",
    name: "Nyhavn",
    tag: "The Postcard Harbour",
    color: "#005DE8",
    blurb:
      "The candy-coloured townhouses everyone photographs. Grab a canal tour, an overpriced beer, and lean into the cliché — it's worth it.",
    highlights: ["Canal tours", "Harbour beers", "Hans Christian Andersen's house"],
    image:
      "https://images.unsplash.com/photo-1521240104483-b3e91583366c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "vesterbro",
    name: "Vesterbro",
    tag: "Grit & Craft Beer",
    color: "#FFD700",
    blurb:
      "Formerly the red-light district, now the coolest corner in town. The Meatpacking District (Kødbyen), Mikkeller and Istedgade's nightlife.",
    highlights: ["Kødbyen", "Mikkeller Bar", "Istedgade", "Enghave Plads"],
    image:
      "https://images.unsplash.com/photo-1764756719784-7e46c361e0ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "norrebro",
    name: "Nørrebro",
    tag: "Multicultural Cool",
    color: "#FF4D00",
    blurb:
      "The most diverse, creative and affordable district. Jægersborggade's tiny shops, Assistens Cemetery walks and the wild Superkilen park.",
    highlights: ["Jægersborggade", "Superkilen", "Assistens Cemetery", "The Lakes"],
    image:
      "https://images.unsplash.com/photo-1768661608031-49dd50e00696?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "christianshavn",
    name: "Christianshavn",
    tag: "Canals & Christiania",
    color: "#005DE8",
    blurb:
      "Charming canals, houseboats and Freetown Christiania — the self-governing hippie enclave. Refshaleøen's street food is next door.",
    highlights: ["Freetown Christiania", "Reffen Street Food", "Our Saviour's Church", "CopenHill"],
    image:
      "https://images.unsplash.com/photo-1551651767-d5ffbdd04b83?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const ATTRACTIONS = [
  { name: "Nyhavn", area: "Nyhavn", note: "The most photographed street in Scandinavia.", span: "sm" },
  { name: "Tivoli", area: "Indre By", note: "The 1843 pleasure garden that inspired Disneyland. Magic after dark.", span: "sm" },
  { name: "Christiania", area: "Christianshavn", note: "A car-free, self-governed world within the city.", span: "sm" },
  { name: "Reffen Street Food", area: "Refshaleøen", note: "50+ waterfront stalls — the city's tastiest hangout.", span: "sm" },
];

// Bakeries are a national obsession — this is the headline food section.
export const BAKERIES = [
  { name: "Sankt Peders Bageri", area: "Indre By", signature: "Charming", note: "CPH's oldest bakery (1652). Locals queue for the giant cinnamon buns on Wednesdays.", addresses: [{ street: "Sankt Peders Stræde 29", locality: "1453 København K" }] },
  { name: "La Glace", area: "Indre By", signature: "Layer cakes", note: "Denmark's oldest confectionery (1870). Old-world cakes under chandeliers.", addresses: [{ street: "Skoubogade 3", locality: "1158 København K" }] },
  { name: "Buka", area: "Indre By · Frederiksberg", signature: "Filled croissants", note: "The croissant specialists — four shops across the city, all serving their famous filled croissants. The pistachio is the one.", addresses: [
    { street: "Store Kongensgade 18", locality: "1264 København K" },
    { street: "Frederiksberggade 21", locality: "1459 København K" },
    { street: "Esplanaden 14", locality: "1263 København K" },
    { street: "Falkoner Allé 26B", locality: "2000 Frederiksberg" },
  ] },
  { name: "Andersen & Maillard", area: "Indre By · Nørrebro · Nordhavn", signature: "Brunsviger-croissant", note: "Tebirkes, kanelsnegle and a special brunsviger-croissant — three shops across the city.", addresses: [
    { street: "Ny Østergade 15", locality: "1101 København K" },
    { street: "Nørrebrogade 62", locality: "2200 København N" },
    { street: "Antwerpengade 10", locality: "2150 Nordhavn" },
  ] },
  { name: "Bageriet BRØD", area: "Vesterbro", signature: "Organic sourdough", note: "The little organic bakery right on Enghave Plads — sourdough and morning buns by the square.", addresses: [{ street: "Enghave Plads 7", locality: "1670 København V" }] },
  { name: "Andersen Bakery", area: "Islands Brygge", signature: "Cakes & pastries", note: "A fancy harbourside bakery on Islands Brygge — beautiful cakes, pastries and good coffee by the water.", addresses: [{ street: "Thorshavnsgade 26", locality: "2300 København S" }] },
  { name: "Juno the Bakery", area: "Østerbro", signature: "Cardamom bun", note: "The cardamom bun that broke the internet. Go early — they sell out.", addresses: [{ street: "Århusgade 48", locality: "2100 København Ø" }] },
  { name: "Bosses Bager", area: "Østerbro", signature: "Old school", note: "A no-nonsense Østerbro bakery beloved for good-value pastries.", addresses: [{ street: "Østerbrogade 132", locality: "2100 København Ø" }] },
  { name: "Det Rene Brød", area: "Østerbro · Frederiksberg", signature: "Organic", note: "The organic one — stone-milled flour, long ferments and proper Danish rye.", addresses: [
    { street: "Rosenvængets Allé 17", locality: "2100 København Ø" },
    { street: "Aksel Møllers Have 2", locality: "2000 Frederiksberg" },
  ] },
  { name: "Københavns Bageri", area: "Carlsberg Byen", signature: "Traditional kringle", note: "A proper neighbourhood bakery in Carlsberg Byen — get an old, traditional Danish kringle.", addresses: [{ street: "Flaskehalsen 22", locality: "1778 København V" }] },
  { name: "Eriks Bageri", area: "Amager", signature: "Proper old school", note: "A bakery on this corner since 1923 — a proper old-school counter with the classic pastries and cakes in generous sizes. The drømmekage is the one to get.", addresses: [{ street: "Amagerbrogade 176", locality: "2300 København S" }] },
  { name: "Lille Bakery", area: "Refshaleøen", signature: "The BMO", note: "Worth the trip to Refshaleøen for the perfect 'BMO' — a bun with cheese. Note: no photos allowed inside.", addresses: [{ street: "Refshalevej 213A", locality: "1432 København K" }] },
  { name: "Hart Bageri", area: "All over town", signature: "Sourdough & morning buns", note: "Richard Hart's (ex-Noma) temple of bread, with shops all over the city — you're never far from one. The best croissants in town.", addresses: [
    { street: "Refshalevej 159A", locality: "1432 København K" },
    { street: "Store Kongensgade 75", locality: "1264 København K" },
    { street: "Gammel Mønt 4", locality: "1117 København K" },
    { street: "Galionsvej 41", locality: "1437 København K" },
    { street: "Victor Borges Plads 2", locality: "2100 København Ø" },
    { street: "Julius Bloms Gade 32", locality: "2200 København N" },
    { street: "Ravnsborggade 1", locality: "2200 København N" },
    { street: "Høkerboderne 17", locality: "1712 København V" },
    { street: "Franciska Clausens Plads 29", locality: "1799 København V" },
    { street: "Gammel Kongevej 109", locality: "1850 Frederiksberg C" },
    { street: "Islands Brygge 23", locality: "2300 København S" },
  ] },
];

// Kept light and guide-y — markets, street food, drinks. No restaurant listings.
export const FOOD = [
  { name: "Danish classics", kind: "The national dish & more", where: "Bodegas & old inns", desc: "Stegt flæsk, flæskesteg, frikadeller — the plates Danes actually grow up on, and where to try them.", to: "/danish-food" },
  { name: "Smørrebrød", kind: "Danish classic", where: "Classic lunch cellars", desc: "Open-faced rye sandwiches, stacked high. The everyday Danish lunch.", to: "/smorrebrod" },
];

export const BIKE_TIPS = [
  "First things first: if you're not used to biking, get some practice in before you come — or at least before you ride straight into Nyhavn harbour.",
  "Riding in a group? Go single file, one behind the other — never side by side.",
  "Bike on the right, overtake on the left. Stick an arm out to the side when turning, and raise a flat hand to signal you're stopping.",
  "Ride in the bike lane — never the pavement or the road. Keep looking around you and mind pedestrians and other cyclists.",
  "Lights are mandatory and fined after dark. Most rentals include them.",
  "Copenhageners are pros on two wheels — if you're not a confident cyclist, just walk or hop on the Metro.",
];

export const TRANSPORT = [
  { title: "On Foot", desc: "The old town is tiny. Most sights are a 20-min walk apart." },
  { title: "Transport", desc: "Metro, trains and buses on one ticket — the Metro runs 24/7, airport in 15 min.", link: "/transport" },
  { title: "Rental Bikes", desc: "400 km of protected lanes — rent from your hotel or an app, drop it at any dock.", link: "/biking", linkText: "How to bike here" },
];

export const STAY = [
  { name: "Steel House", type: "Design hostel", area: "Vesterbro", price: "From ~475 DKK", note: "Pool, cinema, gym — a hostel that thinks it's a hotel." },
  { name: "Next House Copenhagen", type: "Design hostel", area: "Bernstorffsgade", price: "From ~450 DKK", note: "Big, modern hostel by Central Station and Tivoli — pods, dorms and private rooms." },
];

export const STAY_TIPS = [
  "Base yourself in Vesterbro or near Nørreport — walkable to everything and cheaper than the harbour.",
  "Book 8–10 weeks ahead. Copenhagen sells out fast in summer.",
  "Shoulder season (April–May, Sept–Oct) is 30–40% cheaper and just as pretty.",
  "A dorm bed beats a 1h public-transport-dependent hotel on the outskirts every time.",
];

// Full accommodation directory — used by the "Where to stay" page.
// Prices are rough "from" nightly rates in DKK and easy to adjust.
export const ACCOMMODATION = [
  {
    id: "hostels",
    label: "Hostels",
    kicker: "Beds from ~450 DKK",
    color: "#DF3226",
    blurb: "Design-led, social and central — Copenhagen's hostels punch well above their price.",
    places: [
      { name: "Next House Copenhagen", area: "Central Station", price: "From ~450 DKK", link: "https://www.booking.com/Share-zuXZPS9", nearTivoli: true, note: "Big, modern hostel by Central Station and Tivoli — pods, dorms and private rooms." },
      { name: "MEININGER Hotel Copenhagen", area: "Vesterbro", price: "From ~500 DKK", link: "https://www.booking.com/Share-MNzADnr", note: "Hotel-hostel hybrid on a quiet Colbjørnsensgade stretch — dorms and private rooms a 5-minute walk from Central Station." },
      { name: "Capsule Hotel Copenhagen", area: "Vesterbro", price: "From ~760 DKK", color: "#0E7C5A", link: "https://www.booking.com/Share-IJyF1q", note: "Compact sleep-pods near the Meatpacking District — privacy on a budget for solo travellers." },
      { name: "CityHub Copenhagen", area: "Vesterbro", price: "From ~600 DKK", link: "https://www.booking.com/Share-nT4HLW", note: "Futuristic two-person 'hubs' with mood lighting and app-controlled everything — a high-tech pod stay on Vesterbrogade." },
    ],
  },
  {
    id: "budget-hotels",
    label: "Lower-budget hotels",
    kicker: "Doubles from ~650 DKK",
    color: "#1E3A8A",
    blurb: "Private rooms without the sting — simple, central and well connected.",
    places: [
      { name: "CabInn City", area: "Central Station", price: "From ~650 DKK", link: "https://www.booking.com/Share-zvGK27", nearTivoli: true, note: "Ferry-cabin-sized rooms — compact and cheap. It's on this list for the central placement: steps from Tivoli and the station." },
      { name: "Wakeup Copenhagen - Borgergade", area: "Nyhavn", price: "From ~850 DKK", color: "#E8590C", link: "https://www.booking.com/Share-UCo8sR", note: "Clever, compact Arne Jacobsen–ish rooms on Borgergade, a short walk from Nyhavn." },
      { name: "Zoku Copenhagen", area: "Amager", price: "From ~799 DKK", link: "https://www.booking.com/Share-hJU6mJ", note: "Design-led loft aparthotel on Amagerfælledvej — kitchen in every loft, rooftop garden, and a quick metro hop to the centre." },
      { name: "Rye115 Hotel", area: "Østerbro", price: "From ~900 DKK", link: "https://www.booking.com/Share-78fxmg", note: "Small, family-run hotel on quiet Ryesgade — classic Østerbro charm and rare value for the neighbourhood." },
    ],
  },
  {
    id: "three-star",
    label: "3-star hotels",
    kicker: "Doubles from ~720 DKK",
    color: "#C2410C",
    blurb: "Great-value three-star stays with a central address.",
    places: [
      { name: "ProfilHotels Richmond", area: "Vesterbro", price: "From ~722 DKK", link: "https://www.booking.com/Share-6SqrzYG", nearTivoli: true, note: "Straightforward, comfortable rooms a short walk from Central Station." },
      { name: "CPH Hotel", area: "Vesterbro", price: "From ~833 DKK", link: "https://www.booking.com/Share-G3rtyvi", note: "Simple, well-kept rooms in the heart of buzzy Vesterbro." },
      { name: "Ibsens Hotel", area: "Indre By", price: "From ~949 DKK", link: "https://www.booking.com/Share-18WamIb", note: "Characterful boutique by the lakes and Nørreport — a Guldsmeden favourite." },
      { name: "Hotel Bethel", area: "Nyhavn", price: "From ~1,345 DKK", link: "https://www.booking.com/Share-ck8z2is", note: "Simple, spotless rooms right on the Nyhavn canal — the location alone is worth it." },
    ],
  },
  {
    id: "four-star",
    label: "4-star hotels",
    kicker: "Doubles from ~900 DKK",
    color: "#0E7C6B",
    blurb: "Design and dependable comfort in prime spots around the city.",
    places: [
      { name: "Imperial Hotel", area: "Vesterport", price: "From ~899 DKK", link: "https://www.booking.com/Share-RKjYCZj", nearTivoli: true, note: "Danish-design classic by Vesterport station — calm, central and understated." },
      { name: "WIDE Hotel", area: "Indre By", price: "From ~899 DKK", link: "https://www.booking.com/Share-c86rkY", note: "Bright, good-value rooms on Studiestræde in the Latin Quarter — walk to everything." },
      { name: "The Square", area: "City Hall Square", price: "From ~899 DKK", link: "https://www.booking.com/Share-z2W3im", nearTivoli: true, note: "Contemporary hotel right on City Hall Square with a top-floor breakfast view." },
      { name: "NH Copenhagen Grand Joanne", area: "Tivoli", price: "From ~949 DKK", color: "#B8860B", link: "https://www.booking.com/Share-gamdAw", nearTivoli: true, note: "Sleek design hotel with a rooftop bar, moments from Tivoli and Central Station." },
      { name: "Hotel Skt. Annæ", area: "Amalienborg", price: "From ~1,075 DKK", link: "https://www.booking.com/Share-T55Ql3", note: "Historic boutique tucked into a quiet street by Amalienborg — old-Copenhagen charm, minutes from Nyhavn." },
    ],
  },
  {
    id: "five-star",
    label: "5-star hotels",
    kicker: "Doubles from ~1,500 DKK",
    color: "#B8860B",
    blurb: "The splurge list — landmark luxury for a special Copenhagen stay.",
    places: [
      { name: "Villa Copenhagen", area: "Central Station", price: "From ~1,700 DKK", link: "https://www.booking.com/Share-jp1DKMt", nearTivoli: true, note: "Grand old post office turned design hotel by Central Station — courtyard, rooftop pool and serious style." },
      { name: "Admiral Hotel Copenhagen", area: "Near Nyhavn", price: "From ~1,599 DKK", color: "#1E3A8A", link: "https://www.booking.com/Share-ZHpKy1", note: "Converted 1787 harbourside warehouse with vast timber beams, between Amalienborg and Nyhavn." },
      { name: "NH Collection Copenhagen", area: "Christianshavn", price: "From ~1,500 DKK", link: "https://www.booking.com/Share-mNiH1C", note: "In cosy Christianshavn, near the city centre. Walking distance to Christiania, Christiansborg and Broens Gadekøkken." },
      { name: "Manon Les Suites Guldsmeden", area: "By the lakes", price: "From ~2,499 DKK", link: "https://www.booking.com/Share-zb63mvd", note: "Bali-inspired jungle hotel with a lush plant-filled atrium with indoor pool. Too beautiful not to mention." },
    ],
  },
];


export const MANIFESTO = [
  {
    n: "01",
    title: "Two days? Doable.",
    body:
      "A weekend covers the greatest hits — Nyhavn, Tivoli, a canal tour and one great dinner. Fast, photogenic, and enough to fall for the place.",
  },
  {
    n: "02",
    title: "Three days is the sweet spot.",
    body:
      "Add a full neighbourhood — Nørrebro or Vesterbro — plus Christiania and a proper bike day. This is the trip we'd recommend to almost everyone.",
  },
  {
    n: "03",
    title: "Four days? Now you live here.",
    body:
      "Day-trip to a harbour bath or Louisiana museum, slow mornings in cafés, and the confidence to get gloriously, deliberately lost.",
  },
];

// ---- Rule-based planner ----

export const INTERESTS = [
  { id: "culture", label: "Culture & History" },
  { id: "food", label: "Food & Drink" },
  { id: "outdoors", label: "Outdoors & Bikes" },
  { id: "nightlife", label: "Nightlife" },
  { id: "hidden", label: "Hidden Gems" },
  { id: "family", label: "Family Friendly" },
];

// slot: morning | afternoon | evening
const POOL = [
  { title: "Cardamom buns at Juno the Bakery", slot: "morning", area: "Østerbro", tags: ["food", "hidden"] },
  { title: "Croissants at Hart Bageri", slot: "morning", area: "Frederiksberg", tags: ["food"] },
  { title: "Coffee at Coffee Collective", slot: "morning", area: "Nørrebro", tags: ["food", "hidden"] },
  { title: "Climb Rundetårn", slot: "morning", area: "Indre By", tags: ["culture", "family"] },
  { title: "Stroll Strøget & the old town", slot: "morning", area: "Indre By", tags: ["culture", "family"] },
  { title: "Rosenborg Castle & Crown Jewels", slot: "morning", area: "Indre By", tags: ["culture"] },
  { title: "Almond croissant at Democratic Coffee", slot: "morning", area: "Indre By", tags: ["food", "hidden"] },
  { title: "Rent a bike & ride the Lakes", slot: "morning", area: "Nørrebro", tags: ["outdoors"] },

  { title: "Canal tour from Nyhavn", slot: "afternoon", area: "Nyhavn", tags: ["culture", "family"] },
  { title: "Explore Freetown Christiania", slot: "afternoon", area: "Christianshavn", tags: ["hidden", "culture"] },
  { title: "Lunch at Torvehallerne market", slot: "afternoon", area: "Nørreport", tags: ["food", "family"] },
  { title: "Wander Jægersborggade shops & bakeries", slot: "afternoon", area: "Nørrebro", tags: ["hidden", "food"] },
  { title: "Ski / hike up CopenHill", slot: "afternoon", area: "Refshaleøen", tags: ["outdoors", "family"] },
  { title: "Swim at Islands Brygge harbour bath", slot: "afternoon", area: "Islands Brygge", tags: ["outdoors", "family"] },
  { title: "Pastries & wine at Lille Bakery", slot: "afternoon", area: "Refshaleøen", tags: ["food", "hidden"] },
  { title: "The Little Mermaid & Kastellet walk", slot: "afternoon", area: "Østerbro", tags: ["culture", "outdoors"] },

  { title: "Tivoli Gardens after dark", slot: "evening", area: "Indre By", tags: ["family", "culture"] },
  { title: "Street food & beers at Reffen", slot: "evening", area: "Refshaleøen", tags: ["food", "outdoors"] },
  { title: "Craft beer crawl at Mikkeller", slot: "evening", area: "Vesterbro", tags: ["nightlife", "food"] },
  { title: "Hot dogs from a classic pølsevogn", slot: "evening", area: "Indre By", tags: ["food", "family"] },
  { title: "Cocktails on Istedgade", slot: "evening", area: "Vesterbro", tags: ["nightlife"] },
  { title: "Natural wine bar in Nørrebro", slot: "evening", area: "Nørrebro", tags: ["nightlife", "hidden"] },
  { title: "Sunset harbour beers in Nyhavn", slot: "evening", area: "Nyhavn", tags: ["food", "family"] },
];

const SLOTS = ["morning", "afternoon", "evening"];
const SLOT_LABEL = { morning: "Morning", afternoon: "Afternoon", evening: "Evening" };

export function generateItinerary(days, interestIds) {
  const active = interestIds && interestIds.length ? interestIds : INTERESTS.map((i) => i.id);
  const used = new Set();
  const plan = [];

  for (let d = 0; d < days; d++) {
    const slots = SLOTS.map((slot) => {
      const candidates = POOL.filter(
        (p) => p.slot === slot && p.tags.some((t) => active.includes(t)) && !used.has(p.title)
      );
      const fallback = POOL.filter((p) => p.slot === slot && !used.has(p.title));
      const pick = (candidates.length ? candidates : fallback)[0];
      if (pick) used.add(pick.title);
      return {
        slot,
        label: SLOT_LABEL[slot],
        activity: pick || { title: "Free time — get gloriously lost", area: "Anywhere" },
      };
    });
    plan.push({ day: d + 1, slots });
  }
  return plan;
}
